import { ISelectOption, TFnWithArgs, TNullable } from '@ftd/types'
import { Select as MantineSelect, type SelectProps } from '@mantine/core'
import { useState } from 'react'

export type TSelectProps = {
  allowNoValue?: boolean
  opts: ISelectOption[]
  onChange?: TFnWithArgs
  helperText?: string | React.ReactNode
} & Partial<Omit<SelectProps, 'onChange'>>

export const Select: React.FC<TSelectProps> = ({ onChange, ...props }) => {
  const [value, setValue] = useState<TNullable<string>>('')

  const handleChange = (value: TNullable<string>) => {
    setValue(value)
    onChange?.(value)
  }

  return (
    <MantineSelect
      searchable
      clearable
      selectFirstOptionOnChange
      value={value}
      onChange={handleChange}
      autoComplete="off"
      autoFocus={false}
      {...props}
    />
  )
}
